import React from 'react';

/**
 * Catches render errors in child trees so a single bad panel does not blank the whole app.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error?.message || error, info?.componentStack);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[100dvh] flex flex-col items-center justify-center p-6 bg-gray-50">
          <div className="mf-card max-w-md p-6 text-center">
            <h1 className="mf-heading-sm">Something went wrong</h1>
            <p className="mf-body mt-2">
              An unexpected error occurred. Try reloading the application. If this persists, note
              what you clicked and contact support.
            </p>
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <pre className="text-left text-xs bg-gray-100 p-2 rounded mt-3 overflow-auto max-h-36 text-gray-800">
                {this.state.error.message}
              </pre>
            )}
            <button
              type="button"
              className="mt-4 mf-btn-primary w-full"
              onClick={this.handleReload}
            >
              Reload application
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
